import { Skeleton } from '@/components/ui';

function ItemSkeleton() {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-border bg-card p-4">
      <Skeleton className="h-5 w-5 rounded shrink-0 mt-0.5" />
      <div className="flex-1 flex flex-col gap-1.5">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-1/3" />
      </div>
    </div>
  );
}

/**
 * Content-only skeleton for ScheduleTab.
 * Headers (hamburger, month, date strip, pills) render as real components above this.
 */
export function ScheduleTabSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      {/* Date heading */}
      <Skeleton className="h-5 w-36" />

      <ItemSkeleton />
      <ItemSkeleton />
      <ItemSkeleton />
    </div>
  );
}
